/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type WordleHistoryItem = {
    playId: string;
    /**
     * Date in YYYY-MM-DD format
     */
    date: string;
    /**
     * Play status: 0=in_progress, 10=completed, 20=timed_out
     */
    status: WordleHistoryItem.status;
    /**
     * True if won, false if lost, null if in progress or timed out
     */
    won?: boolean | null;
    guessCount: number;
    guesses: Array<string>;
    answerWord: string;
    score?: number | null;
};
export namespace WordleHistoryItem {
    /**
     * Play status: 0=in_progress, 10=completed, 20=timed_out
     */
    export enum status {
        '_0' = 0,
        '_10' = 10,
        '_20' = 20,
    }
}

